export enum OrderListKind {
    Shopping = 'shopping',
    Label = 'label',
}